import React from 'react';
import { createPortal } from 'react-dom';

/** Render overlays on document.body so Card collapse chrome cannot stack above them. */
export const ModalPortal: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  createPortal(children, document.body);
